// Project Imports
import axiosInstance from 'providers/axiosInstance/axiosInstance';

type UpdateParams = {
  apiUrl: string;
  resource: string;
  id: string | number;
  variables: Record<string, unknown>;
  meta?: { query?: Record<string, string | number> };
};

const update = async ({
  resource,
  id,
  variables,
  apiUrl,
  meta,
}: UpdateParams) => {
  let url = `${apiUrl}/${resource}/${id ? `${id}/` : ''}`;
  if (meta?.query) {
    const params = new URLSearchParams(
      meta.query as Record<string, string>
    ).toString();
    url += `?${params}`;
  }
  const { data } = await axiosInstance.put(url, variables);
  return {
    data,
  };
};

export default update;
